<div class="col-sm-12">
  <app-card [hidHeader]="true" cardClass="card-datatable">
    <div class="table-responsive">
      <table *ngIf="etat" datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
        <thead class="thead-light">
          <tr>
            <th>Bailleur</th>
            <th>Bien</th>
            <th>Mandat</th>
            <th>Commission</th>
            <th>Montant</th>
            <th>Date</th>
            <th>État</th>
            <th *ngIf="action">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of renews">
            <td class="align-middle">
              <p class="m-0 d-inline-block align-middle font-16">
                {{item?.mandate?.house?.owner?.searchableTitle}}
              </p>
            </td>
            <td class="align-middle">
              <p class="m-0 d-inline-block align-middle font-16">
                <span class="text-warning">{{item?.mandate?.house?.nom}}</span>
              </p>
            </td>
            <td class="align-middle">
              <p class="m-0 d-inline-block align-middle font-16">{{ item?.mandate.libelle }}</p>
            </td>
            <td>{{item?.commission}} %</td>
            <td>
              <p class="m-0 d-inline-block align-middle font-16">
                <span class="text-warning">{{item?.montantCom}}</span>
              </p>
            </td>
            <td>{{item.date |date: "d MMMM y" : '' : 'fr-FR'}}</td>
            <td>
              <span class="badge" [ngClass]="{
              'badge-success' : item?.etat === 'ACTIF',
              'badge-warning' : item?.etat === 'INACTIF',
              'badge-danger' : item?.etat === 'EXPIRER'
              }">{{item.etat}}</span>
            </td>
            <td class="table-action">
              <div class="overlay-edit">
                <button (click)="showRenewMandate(item)" type="button" class="btn btn-icon btn-secondary"
                  ngbTooltip="Détails">
                  <i class="fas fa-eye"></i>
                </button>
                <ng-template ngxPermissionsOnly="RENEW:MANDATE:EDIT">
                  <button *ngIf="item?.etat === 'INACTIF'" (click)="editRenewMandate(item)" type="button" class="btn btn-icon btn-primary ml-1"
                    ngbTooltip="Modifier">
                    <i class="feather icon-edit-2"></i>
                  </button>
                </ng-template>
                <ng-template ngxPermissionsOnly="RENEW:MANDATE:ACTIVATE">
                  <button *ngIf="item?.etat === 'INACTIF'" (click)="activateRenewMandate(item)" type="button" class="btn btn-icon  btn-success ml-1" ngbTooltip="Activer">
                    <i class="fas fa-check"></i>
                  </button>
                </ng-template>
                <button *ngxPermissionsOnly="'RENEWMANDATE:PRINTER:SHOW'" (click)="printerRenewMandate(item)" type="button" class="btn btn-icon btn-warning ml-1"
                  ngbTooltip="Imprimer">
                  <i class="feather icon-printer"></i>
                </button>
                <ng-template ngxPermissionsOnly="RENEW:MANDATE:DELETE">
                  <button *ngIf="item?.etat === 'INACTIF'" type="button" (click)="delete(item)" class="btn btn-icon btn-danger ml-1" ngbTooltip="Supprimer">
                    <i class="feather icon-trash"></i>
                  </button>
                </ng-template>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4" class="font-weight-bold font-size-40 text-right">TOTAL</td>
            <td class="font-weight-bold font-size-40 text-warning"> {{total | number}} {{global.device}}</td>
            <td *ngIf="action"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </app-card>
</div>
